import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ui-panel ui-table-scroll" }
const _hoisted_2 = { class: "ui-table expiration-table" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "num whitespace-nowrap" }
const _hoisted_5 = { class: "num" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted-foreground"
}
const _hoisted_8 = {
  key: 1,
  class: "support-meta mt-1"
}
const _hoisted_9 = {
  key: 0,
  class: "support-meta-row"
}
const _hoisted_10 = {
  key: 1,
  class: "support-meta-row"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 1,
  class: "text-muted-foreground"
}
const _hoisted_13 = { class: "text-xs text-muted-foreground" }

import { Badge } from '@/components/ui/badge';

import { useRouter } from 'vue-router';
import moment from 'moment';

interface Props {
  items: ExpirationItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpirationCard',
  props: {
    items: {}
  },
  setup(__props: any) {


const router = useRouter();

function goToProperty(id: number) {
  router.push({ name: 'property-detail', params: { id } });
}

function formatDate(date: string): string {
  return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
}

function daysLabel(days: number): string {
  if (days < 0) return `−${Math.abs(days)} дн.`;
  if (days === 0) return 'Сегодня';
  return `${days} дн.`;
}

function rowClass(item: ExpirationItem) {
  if (item.support_suspended) return 'row-suspended';
  if (item.days_left < 0) return 'row-overdue';
  if (item.days_left <= 7) return 'row-soon';
  return '';
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "num" }, "Срок"),
          _createElementVNode("th", { class: "num" }, "Осталось"),
          _createElementVNode("th", null, "Клиент"),
          _createElementVNode("th", null, "Тип"),
          _createElementVNode("th", null, "Продукт / модуль"),
          _createElementVNode("th", null, "Саппортер"),
          _createElementVNode("th", null, "Комментарий"),
          _createElementVNode("th", null, "Менеджер")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `${item.kind}-${item.property.id}-${item.product.id}-${item.module?.id ?? 's'}-${item.expires_on}`,
            class: _normalizeClass([rowClass(item), "expiration-row"]),
            onClick: ($event: any) => (goToProperty(item.property.id))
          }, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(formatDate(item.expires_on)), 1),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_unref(Badge), {
                variant: 
                item.days_left < 0 ? 'destructive' : item.days_left <= 30 ? 'warning' : 'success'
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(daysLabel(item.days_left)), 1)
                ]),
                _: 2
              }, 1032, ["variant"]),
              (item.support_suspended)
                ? (_openBlock(), _createBlock(_unref(Badge), {
                    key: 0,
                    variant: "destructive",
                    class: "ml-1"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Пауза", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                to: { name: 'property-detail', params: { id: item.property.id } },
                class: "property-link ui-link font-medium",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.property.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("td", null, [
              _createVNode(_unref(Badge), {
                variant: item.kind === 'support' ? 'secondary' : 'outline'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.kind === 'support' ? 'Поддержка' : 'Лицензия'), 1)
                ]),
                _: 2
              }, 1032, ["variant"])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.product.name), 1),
              (item.module)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "· " + _toDisplayString(item.module.name), 1))
                : _createCommentVNode("", true),
              (item.support_types?.length || item.support_24on7 || item.support_weekend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (item.support_types?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xs text-muted-foreground" }, "Тип:", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.support_types, (supportType) => {
                            return (_openBlock(), _createBlock(_unref(Badge), {
                              key: supportType,
                              variant: "secondary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(supportType), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (item.support_24on7 || item.support_weekend)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-xs text-muted-foreground" }, "Режим:", -1)),
                          (item.support_24on7)
                            ? (_openBlock(), _createBlock(_unref(Badge), {
                                key: 0,
                                variant: "outline"
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("24/7", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (item.support_weekend)
                            ? (_openBlock(), _createBlock(_unref(Badge), {
                                key: 1,
                                variant: "outline"
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode("выходные", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, _toDisplayString(item.supporter?.name || '—'), 1),
            _createElementVNode("td", null, [
              (item.support_notes)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "notes-text",
                    title: item.support_notes
                  }, _toDisplayString(item.support_notes), 9, _hoisted_11))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
            ]),
            _createElementVNode("td", _hoisted_13, _toDisplayString(item.property.manager || item.property.sales_manager || '—'), 1)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}
}

})